import { IconSearch16, Input, InputAdornment } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubAgentSearchInput.css';

type TSubAgentSearchInput = {
  value: string;
  onChange: (value: string) => void;
  isLoading: boolean;
};

export const SubAgentSearchInput: React.FC<TSubAgentSearchInput> = ({ value, onChange, isLoading }) => {
  return (
    <div className={styles['container']}>
      <Input
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        leftAdornment={
          <InputAdornment>
            <IconSearch16 />
          </InputAdornment>
        }
        size="M"
        loading={isLoading}
        placeholder="Введите имя сотрудника"
      />
    </div>
  );
};
